import { NavigateOptions, To, useNavigate } from 'react-router-dom';

import { useDirtyFormContext } from '~/contexts/DirtyFormContext';

export const useGuardedNavigate = () => {
  const navigate = useNavigate();
  const { confirmIfDirty } = useDirtyFormContext();

  return (to: To, options?: NavigateOptions) => confirmIfDirty(() => void navigate(to, options));
};
